import React from 'react'
import { Link } from 'react-router-dom'

function Breadcrumb(props) {
  return (
   <>
    <section className="hero-section ptb-100 gradient-overlay"
            style={{background: "url(assets1/img/header-bg-5.jpg)",
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            }}>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-7">
                    <div className="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                        <h3 className="text-white mb-0">{props.tag}</h3>
                        <div className="custom-breadcrumb">
                            <ol className="breadcrumb d-inline-block bg-transparent list-inline py-0">
                                <li className="list-inline-item breadcrumb-item"><Link to="Website-Desgn">Home</Link></li>                          
                                <li className="list-inline-item breadcrumb-item " style={{textTransform: 'uppercase'}}>{props.title}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
   </>
  )
}

export default Breadcrumb
